import { IGuideButtons } from "../../../interfaces";
import ARROWLEFTBLUE from "../../../assets/images/GuideButtons/ArrowLeftBlue.png";
import ARROWRIGHTBLUE from "../../../assets/images/GuideButtons/ArrowRightBlue.png";
import "../style/GuideButtons.css";

export const GuideButtons = (params: IGuideButtons) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: 0,
        overflow: "hidden",
        paddingLeft: "10vw",
        top: 0,
        height: "100%",
        pointerEvents: "none",
      }}
    >
      <div
        className={
          params.spreadMenu ? "buttons_wrapper_hover" : "buttons_wrapper"
        }
        style={{ pointerEvents: "all" }}
      >
        {params.ReadenMarkers > params.markers.length - 1 ? (
          <img
            src={!params.spreadMenu ? ARROWLEFTBLUE : ARROWRIGHTBLUE}
            alt=""
            onClick={() => params.setSpreadMenu(!params.spreadMenu)}
            style={{
              position: "absolute",
              top: "50%",
              left: "-10%",
              transform: "translate(0, -50%)",
              width: "7%",
              cursor: "pointer",
            }}
          />
        ) : null}
        {params.markers.map((e, i) => {
          return (
            <div
              key={i}
              className="slide_button_div"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                width: "100%",
              }}
            >
              <div
                style={
                  params.ReadenMarkers === i
                    ? {
                        transform: "translate(-90%,0)",
                        transition: "0.5s",
                      }
                    : { transition: "0.5s" }
                }
                className={
                  !params.spreadMenu
                    ? params.ReadenMarkers + 1 > i
                      ? "slide_button_div_block"
                      : "slide_button_unactive"
                    : "slide_button_unmove"
                }
              >
                <button
                  //   style={
                  //     params.ReadenMarkers === i
                  //       ? {
                  //           transform: "translate(-90%,0)",
                  //           transition: "0.5s",
                  //         }
                  //       : { transition: "0.5s" }
                  //   }
                  className={
                    !params.spreadMenu
                      ? params.ReadenMarkers + 1 > i
                        ? "slide_button"
                        : "slide_button_unactive"
                      : "slide_button_unmove"
                  }
                  disabled={params.ReadenMarkers < i}
                  onClick={() => {
                    params.setForModal({
                      title: e.title,
                      content: e.content,
                      text: e.text,
                      list: e.list,
                      table: e.table,
                      damage: e.damage,
                      titletext: e.titletext,
                      maxWidthTable: e.maxWidthTable,
                      minWidthTable: e.minWidthTable,
                    });
                    params.setModalActive(true);
                    if (params.ReadenMarkers === i) {
                      params.AddReadenMarker();
                    }
                  }}
                >
                  <span style={{ float: "left", fontWeight: 700 }}>{e.id}</span>
                  {e.title_short}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
